import { AnimatePresence, motion } from "framer-motion";
import { formatDateTime } from "../../i18n";

function TransactionsModal({ isOpen, onClose, transactions }) {
  if (!isOpen) return null;

  //  Güvenli kontrol
  const hasTransactions = Array.isArray(transactions) && transactions.length > 0;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.2 }}
          className="bg-white p-6 rounded-2xl max-w-5xl w-full shadow-2xl relative border border-gray-200"
        >
          <h2 className="text-2xl font-bold mb-4">İzin Hareketleri</h2>

          <div className="max-h-[450px] w-full overflow-y-auto rounded-lg border border-gray-200">
            {!hasTransactions ? (
              <div className="flex flex-col items-center py-12 text-gray-500">
                <p className="text-base font-medium">
                  Bu kullanıcıya ait izin geçmişi bulunmamaktadır.
                </p>
              </div>
            ) : (
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-gray-100 text-gray-700 text-sm uppercase border-none">
                    <th className="py-3 px-4 border-b">TC</th>
                    <th className="py-3 px-4 border-b">Action Type</th>
                    <th className="py-3 px-4 border-b">Value</th>
                    <th className="py-3 px-4 border-b">Comment</th>
                    <th className="py-3 px-4 border-b">Action By</th>
                    <th className="py-3 px-4 border-b">Tarih</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  {transactions.map((t, idx) => (
                    <tr
                      key={idx}
                      className="border-b hover:bg-gray-50 transition-colors"
                    >
                      <td className="py-2 px-4 font-mono">{t.tc}</td>
                      <td className="py-2 px-4">
                        <p
                          className={`px-2 py-1 rounded text-xs font-medium text-center ${
                            t.actionType === "SYSTEM"
                              ? "bg-blue-100 text-blue-700"
                              : "bg-gray-100 text-gray-700"
                          }`}
                        >
                          {t.actionType}
                        </p>
                      </td>
                      <td
                        className={`py-2 px-4 font-semibold ${
                          t.value > 0 ? "text-green-600" : "text-red-600"
                        }`}
                      >
                        {t.value > 0 ? `+${t.value}` : t.value}
                      </td>
                      <td className="py-2 px-4">{t.comment || "-"}</td>
                      <td className="py-2 px-4 font-mono">
                        {t.actionByDisplay || t.actionBy || "-"}
                      </td>
                      <td className="py-2 px-4 text-gray-600">
                        {formatDateTime(t.createdAt) || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <div className="flex justify-end mt-4">
            <button
              onClick={onClose}
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-lg transition"
            >
              Kapat
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}

export default TransactionsModal;
